import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';
import { EventEmitterAwareInterface } from 'pf-frontend-common/src/module/event/emitter-aware.interface';
import { BrowserDocumentServiceInterface } from 'pf-frontend-common/src/service/browser-document/service.interface';
import { WindowServiceInterface } from 'pf-frontend-common/src/service/window/service.interface';

import { MapboxMapsCssEvent } from 'common/module/mapbox/maps/css.event';

export class MapboxMapsCss implements EventEmitterAwareInterface {
  /**
   * Mapbox css url
   */
  public static readonly mapboxCssUrl: string = 'https://api.tiles.mapbox.com/mapbox-gl-js/v1.9.0/mapbox-gl.css';

  /**
   * Is Google Maps ready for usage?
   */
  protected isReady: boolean = false;

  /**
   * Is the script currently loading?
   */
  protected isLoading: boolean = false;

  /**
   * Queue of Promise.resolve to call once the Google Maps script will be ready
   */
  protected promiseQueue: Array<(success: boolean) => void> = [];

  /**
   * Constructor
   */
  constructor(
    protected eventEmitter: EventEmitterInterface,
    protected browserDocumentService: BrowserDocumentServiceInterface,
    protected windowService: WindowServiceInterface
  ) {}

  /**
   * @inheritDoc
   */
  public getEventEmitter(): EventEmitterInterface {
    return this.eventEmitter;
  }

  /**
   * Load Google Maps script
   */
  public load(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      // Script already ready
      if (this.isReady) {
        resolve(true);
        return;
      }

      // Add resolve function to queue
      this.promiseQueue.push(resolve);

      // Script is loading
      if (this.isLoading) {
        return;
      }

      // Script is now loading
      this.isLoading = true;

      // Import script asynchronously
      this.browserDocumentService.importStylesheet(MapboxMapsCss.mapboxCssUrl).then(this.onReadyMapboxMaps);
    });
  }

  /**
   * Google Maps ready for usage
   */
  protected onReadyMapboxMaps = (): void => {
    this.isReady = true;
    this.isLoading = false;

    // Call every promise.resolve in queue
    this.promiseQueue.forEach((resolve) => resolve(true));

    this.eventEmitter.emit(MapboxMapsCssEvent.ready);
  };
}
